export const COLORS = {
  TRANSPARENT: 'transparent',
  WHITE_VARIANT: '#ffffff',

  ACCENTUATED_VARIANT: '#41a152',
  ACCENTUATED_VARIANT_DARK: '#276131',

  PRIMARY_VARIANT: '#4b4b4b',
  PRIMARY_VARIANT_DARK: '#000000',

  SECONDARY_VARIANT: '#e1e1e1',
  SECONDARY_VARIANT_DARK: '#bcbcbc',

  ALERT_POSITIVE: '#66C39B',
  ALERT_NEGATIVE: '#C9252D',
  ALERT_ALERT: '#FF9900',
  ALERT_INFORMATIVE: '#2C7DD9',

  VARIANTE: '#bcbcbc',
  NEGATIVE_VARIANT: '#c9252d',
  FILTER_BORDER: '#bcbcbc'
};
